import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import CategorySection from '../CategorySection';
import { FEATURED } from '~app/pages/AppsDirectory/components/SearchContext/constants';
import EmptySearchImg from '../../../../static/images/empty-search.svg';
import useStyles from '../../styles';

export const NoResultsCard = ({ searchTerm }) => {
  const { featuredApps, fullWidth } = useStyles();

  return (
    <>
      <Box mb={5} display="grid" gridTemplateRows="240px">
        <Box display="grid" gridTemplateColumns="50% 50%" alignContent="center" placeItems="center">
          <Box className={fullWidth}>
            <Box mb={3}>
              <Typography variant="cardTitle" weight="medium">
                &ldquo;{searchTerm}&rdquo; returned no results
              </Typography>
            </Box>
            <Typography>
              We weren&apos;t able to find a match with our search.
              <br />
              Take a look at the trending integrations below
            </Typography>
          </Box>
          <Box className={fullWidth}>
            <img alt="No search results" src={EmptySearchImg} />
          </Box>
        </Box>
      </Box>
      <Box mb={5} className={featuredApps}>
        <CategorySection queryParams={{ sortBy: FEATURED.value, page: 1, pageSize: 4 }} sectionName="Featured" />
      </Box>
    </>
  );
};
NoResultsCard.propTypes = {
  searchTerm: PropTypes.string.isRequired,
};

export default NoResultsCard;
